export class BfxPublicProfileSaveActionEvent {
  public _callback: any;

  constructor(callback: any) {
    this._callback = callback;
  }
}

export const ENTITY_ALREADY_EXIST = "entity.alreadyExists";
export const PUBLIC_PROFILE_DEFAULT_RESERVED = "public.profile.default.reserved";
